import { InputAdornment, TextField } from "@mui/material";
import React from "react";

const TextFieldNew = ({
  startIcon,
  endIcon,
  fontSize,
  bgColor,
  shrink,
  size,
  variant,
  ...props
}) => {
  return (
    <TextField
      variant={variant || "filled"}
      {...props}
      sx={{
        // backgroundColor: "action.hover",
        borderRadius: 2,
      }}
      size={size || "small"}
      InputProps={{
        style: {
          borderRadius: 7,
          fontSize: fontSize && fontSize,
          backgroundColor: bgColor && bgColor,
        },
        endAdornment: endIcon && (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ),
        startAdornment: startIcon && (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ),
        disableUnderline: true,
      }}
      InputLabelProps={{
        shrink: true,
        style: {
          fontSize: 14,
        },
      }}
    />
  );
};

export default TextFieldNew;
